import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './workspace.scss';

function PageWorkspace({ children, className, ...rest }) {
  return (
    <div
      className={classnames('page-workspace page-workspace--responsive', className)}
      {...rest}
    >
      {children}
    </div>
  );
}

PageWorkspace.defaultProps = {
  children: null,
  className: ''
};

PageWorkspace.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export { PageWorkspace };
